export default __webpack_public_path__ + "static/media/stripe_logo.3ef1d9a5.png";